/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Modalita\' di estensione/riapertura della graduatoria del bando
 */
export enum ModalitaEstensione {

    BUDGET_AI_NUOVI = 'BUDGET_AI_NUOVI',

    BUDGET_A_TUTTI = 'BUDGET_A_TUTTI',

    REDISTRIBUZIONE_AI_NUOVI = 'REDISTRIBUZIONE_AI_NUOVI',

    REDISTRIBUZIONE_A_TUTTI = 'REDISTRIBUZIONE_A_TUTTI',

    REDISTRIBUZIONE_UGUALE_A_TUTTI = 'REDISTRIBUZIONE_UGUALE_A_TUTTI'
}

